<ng-container *ngIf="licenseStatus$ && (licenseStatus$ | async) as licenseStatusModel">
  <div *ngIf="isToShowNotification || isToShowUpgradeNotification"
    class="evaluation evaluation__overlay d-flex justify-content-center align-items-center">
    <div class="evaluation__container"
      [ngClass]="{ 'upgrade': isToShowUpgradeNotification, 'expired': licenseStatusModel.LicenseSupportDaysLeft <= 0 }"
      id="evaluationContainer">
      <div class="evaluation__container__background-image"></div>
      <div *ngIf="isToShowNotification" class="evaluation__content evaluation-notification">

        <div
          class="evaluation__content-box d-flex justify-content-center flex-column align-items-center position-absolute">
          <div class="evaluation__content-box-info">
            <img src="./../../../assets/icons/evaluation-period-notification/support.svg" alt="">
            <span>+</span>
            <img src="./../../../assets/icons/evaluation-period-notification/maintenance.svg" alt="">
            <span>+</span>
            <img src="./../../../assets/icons/evaluation-period-notification/enhancement.svg" alt="">
          </div>
          <div class="evaluation__content-wrapper d-flex flex-column justify-content-between pb-5 pt-4">
            <ng-container *ngIf="licenseStatusModel.LicenseSupportDaysLeft > 0; else expired">
              <h2 class="evaluation__title text-uppercase text-center">
                YOUR MAWi support and maintenance period will be over in {{ licenseStatusModel.LicenseSupportDaysLeft }}
                {{ licenseStatusModel.LicenseSupportDaysLeft > 1 ? ' days' : ' day'}}!
              </h2>
              <div class="evaluation__description mb-4">
                to keep your product up-to-date with all the new features and latest enhancements, in addition to getting
                support by our dedicated tech team, please press here:
              </div>
            </ng-container>

            <ng-template #expired>
              <h2 class="evaluation__title text-uppercase text-center">
                Your maintenance and support period has expired since:
                {{ (licenseInfo$ | async)?.SupportExpirationDate | date: 'dd.MM.yyyy' }}
              </h2>
              <div class="evaluation__description mb-4">
                to receive ongoing updates and enhancements for your product, as well as access to support from
                our dedicated tech team, payment is required:
              </div>
            </ng-template>

            <div class="evaluation__buttons d-flex flex-column justify-content-between w-100 mb-4">
              <button mat-raised-button class="evaluation__button evaluation__button--pink w-100 mb-3">
                <a class="evaluation__button--link white"
                  href="{{ supportExpirationMonthPast > 12 ?
                    'https://monitorsanywhere.com/product/mawi-software-license/' :
                    supportExpirationMonthPast > 6 ?
                    'https://monitorsanywhere.com/product/mawi-monitors-anywhere-web-based-interface-maintenance-and-upgrades-50/' :
                    'https://monitorsanywhere.com/product/mawi-maintenance-and-upgrades-20/' }}"
                    target="_blank">extend support</a>
              </button>
              <button mat-button [matMenuTriggerFor]="menu" class="remind-me-btn" *ngIf="licenseStatusModel.LicenseSupportDaysLeft <= 0">
                Remind me later
                <mat-icon svgIcon="expand_more"></mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button *ngFor="let days of amountOfDays" mat-menu-item (click)="onClose(days)">
                  In {{ days }} {{ days > 1 ? 'days' : 'day' }}
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isToShowUpgradeNotification" class="evaluation__content">
        <div
          class="evaluation__content-box d-flex justify-content-center flex-column align-items-center position-absolute">
          <h2 class="evaluation__title text-uppercase">
            Thank you for upgrading to MAWi V3
          </h2>
          <div class="evaluation__content-wrapper d-flex flex-column justify-content-between pb-5 pt-4">
            <div class="evaluation__description mb-4">
              We’ve noticed that you are currently using the old {{ (licenseInfo$ | async)?.ProductName }} license. The software is currently in trial mode for the next
              {{ licenseStatusModel.LicenseSupportDaysLeft }} {{ licenseStatusModel.LicenseSupportDaysLeft > 1 ? ' days' : ' day'}}.
              Please take action to activate your software license.
            </div>
            <div class="evaluation__description mb-4">
              Your current support and maintenance end date is {{ supportExpirationDate || '—' }}
              <a class="ml-2" href="https://monitorsanywhere.com/software-license-support-and-maintenance/"
                target="_blank">
              <mat-icon svgIcon="help_outline" matTooltip="Support and Maintenance Agreement"></mat-icon>
              </a>
            </div>
            <div class="evaluation__buttons d-flex flex-column justify-content-between w-100 mb-4">
              <button mat-raised-button class="evaluation__button w-100 mb-3" (click)="openActivationLicenseDialog()">
                <a class="evaluation__button--link">Activate your
                  license</a>
              </button>
              <button mat-raised-button class="evaluation__button evaluation__button--pink w-100 mb-3">
                <a class="evaluation__button--link"
                  href="{{ supportExpirationMonthPast > 12 ?
                    'https://monitorsanywhere.com/product/mawi-software-license/' :
                    supportExpirationMonthPast > 6 ?
                    'https://monitorsanywhere.com/product/mawi-monitors-anywhere-web-based-interface-maintenance-and-upgrades-50/' :
                    'https://monitorsanywhere.com/product/mawi-maintenance-and-upgrades-20/' }}"
                    target="_blank">Upgrade your license to MAWi v3</a>
              </button>
            </div>
            <div class="evaluation__key">
              If you have any questions, please <a href="https://monitorsanywhere.com/contact-us/" class="evaluation__link"
                target="_blank">contact us</a>
            </div>
          </div>
        </div>
      </div>

      <div class="signature"></div>

      <div class="what-is-new">
        <img class="mb-2" src="./../../../assets/icons/evaluation-period-notification/what_is_new.svg" alt="">
        <p class="m-0">What’s new in MAWi?</p>
        <a class="evaluation__link" target="_blank" href="https://monitorsanywhere.com/mawi-release-notes/">click
          here</a>
      </div>

      <div class="close-button">
        <span (click)="onClose()" matTooltip="Close notification">&times;</span>
      </div>
    </div>
  </div>
</ng-container>
